export const ModalToggleIcon = ({}) => {
	return (
		<svg width="32" height="29" viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M24.2778 8.19141L7.88124 21.694" stroke="#9E9F9E" stroke-width="3" stroke-linecap="round" />
			<path d="M23.7247 22.1809L8.43457 7.70117" stroke="#9E9F9E" stroke-width="3" stroke-linecap="round" />
		</svg>
	)
}
